import { render, staticRenderFns } from "./CmsContent.vue?vue&type=template&id=73050512&scoped=true"
import script from "./CmsContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CmsContent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73050512",
  null
  
)

export default component.exports